export default __webpack_public_path__ + "static/media/je.08417a85.svg";